module.exports = __webpack_public_path__ + "static/img/school-6.1c5879d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/school-6.png
// module id = UDTp
// module chunks = 0